import React from 'react';
import LegalPage from '@/components/LegalPage';

const RefundPolicy = () => (
  <LegalPage
    title="Refund & Return Policy"
    effectiveDate="February 1, 2026"
    intro="At Raretto, we value your satisfaction and strive to deliver the highest quality products. If you are not completely happy with your purchase, please review our Refund & Return Policy below."
    sections={[
      {
        heading: '1. Eligibility for Returns',
        list: [
          'Perishable goods (like chocolates and food items) are non-returnable unless they arrived damaged, defective, or incorrect.',
        ],
      },
      {
        heading: '2. Incorrect Orders',
        list: [
          'If your order arrives damaged or you receive the wrong item, please contact us within 48 hours of delivery.',
          'We may ask for photographs of the product and packaging for verification.',
          'Once approved, we will issue a replacement or a full refund, as per your preference.',
        ],
      },
      {
        heading: '3. Refund Process',
        list: [
          'Refunds will be processed to your original method of payment within 5–7 business days after inspection/approval.',
          'Shipping charges are non-refundable, unless the return is due to our error (damaged/incorrect product).',
        ],
      },
      {
        heading: '4. Exchanges',
        list: [
          'We do not offer direct exchanges. If you need a different product, please return the original item (if eligible) and place a new order.',
        ],
      },
      {
        heading: '5. How to Initiate a Return',
        paragraphs: [
          'To start a return, please contact us at customersupport@raretto.com or +91 91677 98999.',
          'Provide your order number, product details, and reason for return. Our team will guide you through the process.',
        ],
      },
      {
        heading: '6. Exceptions',
        list: [
          'Opened or partially consumed products cannot be returned.',
          'Gift cards, promotional items, or discounted products may not be eligible for return/refund.',
        ],
      },
      {
        heading: '7. Contact Us',
        paragraphs: [
          'If you have any questions regarding our Refund & Return Policy, please contact us at:',
        ],
        list: [
          'Rajasthan Trading Co. (Brand: Raretto), Worli, Mumbai, Maharashtra 400018',
          'Email: customersupport@raretto.com',
          'Phone: +91 91677 98999',
        ],
      },
    ]}
  />
);

export default RefundPolicy;
